export default "{{message}}\r\n"